function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useRef, useMemo, forwardRef } from 'react';
import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import Icon from "../Icon/Icon";
import getColorLuma from "../../../utils/colors/getColorLuma.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Badge = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    className,
    color,
    text,
    badgeAriaLabel = 'Badge',
    dataTestId,
    shape = 'circle',
    onClick,
    type,
    icon
  } = props;
  if (text === '' || text === undefined) {
    return null;
  }
  const internalRef = useRef(null);
  const badgeRef = ref || internalRef;
  const luma = getColorLuma(color);
  const textColor = luma < 128 ? 'white' : '#4A657F';
  const style = _objectSpread({
    color: textColor,
    backgroundColor: props.color
  }, props.style);
  const badgeBaseClass = 'min-w-6 text-center box-border inline-block text-xs p-1';
  const badgeClass = useMemo(() => {
    const baseClass = shape === 'square' ? 'leading-7 h-10 rounded-none font-heavy-font px-2' : 'leading-3 h-6 rounded-xl';
    return cn(badgeBaseClass, baseClass, {
      'border-solid border border-brand-blue rounded-6 h-6': type === 'filter'
    }, className);
  }, [shape, className, type]);
  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onClick) {
        onClick(e);
      }
    } else if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      e.preventDefault();
    }
  };
  const iconElement = icon !== null && icon !== void 0 && icon.name ? /*#__PURE__*/_jsx(Icon, {
    color: icon === null || icon === void 0 ? void 0 : icon.color,
    icon: icon.name,
    style: icon === null || icon === void 0 ? void 0 : icon.style,
    className: icon === null || icon === void 0 ? void 0 : icon.className
  }) : null;
  return /*#__PURE__*/_jsxs("span", {
    id: id,
    className: badgeClass,
    style: style,
    "aria-label": "".concat(badgeAriaLabel, ": ").concat(text),
    tabIndex: 0,
    role: "button",
    ref: badgeRef,
    onKeyDown: handleKeyDown,
    "data-testid": dataTestId,
    onClick: onClick,
    children: [iconElement && (icon === null || icon === void 0 ? void 0 : icon.position) === "left" && /*#__PURE__*/_jsx("span", {
      className: "mr-1",
      children: iconElement
    }), text, iconElement && (icon === null || icon === void 0 ? void 0 : icon.position) === "right" && /*#__PURE__*/_jsx("span", {
      className: "ml-1",
      children: iconElement
    })]
  });
});
Badge.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string,
  badgeAriaLabel: PropTypes.string,
  dataTestId: PropTypes.string,
  shape: PropTypes.oneOf(['square', 'circle']),
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['filter']),
  icon: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    style: PropTypes.string,
    position: PropTypes.oneOf(['left', 'right']),
    className: PropTypes.string
  })
};
export default Badge;
//# sourceMappingURL=Badge.js.map